var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "root" }, [
    _c("div", { staticClass: "top" }, [_vm._v("套餐升级")]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "package-list" },
      _vm._l(_vm.packagelist, function(item, index) {
        return _c(
          "div",
          {
            key: index,
            staticClass: "package-item",
            class: "c" + _vm.nowPackage.net + "-" + item.net
          },
          [
            _c(
              "div",
              {
                staticClass: "circle",
                on: {
                  click: function($event) {
                    _vm.checked = index
                  }
                }
              },
              [_vm.checked === index ? _c("span", [_vm._v("√")]) : _vm._e()]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "org" }, [
              _c("div", { staticClass: "price" }, [
                _vm._v(_vm._s(_vm.nowPackage.price))
              ]),
              _vm._v(" "),
              _c("div", [_vm._v(_vm._s(_vm.nowPackage.title))])
            ]),
            _vm._v(" "),
            _c("img", {
              staticClass: "jt",
              attrs: { src: _vm.img["img" + _vm.nowPackage.net + item.net] }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "org" }, [
              _c("div", { staticClass: "price" }, [_vm._v(_vm._s(item.price))]),
              _vm._v(" "),
              _c("div", [_vm._v(_vm._s(item.title))])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "btn" }, [
              _c("div", { staticClass: "price" }, [
                _c("span", { staticClass: "yen" }, [_vm._v("¥")]),
                _c("span", [_vm._v(_vm._s(item.diff))])
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "submit",
                  on: {
                    click: function($event) {
                      return _vm.submit(item)
                    }
                  }
                },
                [_vm._v("升级购买")]
              )
            ]),
            _vm._v(" "),
            _c("img", {
              staticClass: "bg",
              attrs: { src: _vm.bimg["bimg" + _vm.nowPackage.net + item.net] }
            })
          ]
        )
      }),
      0
    ),
    _vm._v(" "),
    _vm._m(0)
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "tips" }, [
      _c("div", { staticClass: "tp-title" }, [_vm._v("温馨提示")]),
      _vm._v(" "),
      _c("ul", { staticClass: "tp-content" }, [
        _c("li", [_vm._v("网络服务由当地优质运营商提供，安全靠谱")]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "购买后 30 天之内随时启用，有效期将从启用后开始计算，每 24 小时计为1天，一经启用，无法暂停计时"
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "购买后使用 30 天以内，可在公众号联系客服取消订单在海岛、隧道、山区、高速公路、沙漠等偏远地区，受限于运营商网络覆盖，可能会出现信号较弱和信号丢失的情况"
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "开启热点共享时，建议关闭接入手机的同步、备份等功.能，避免套餐流量消耗过快"
          )
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-51f0b494", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ../app/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-51f0b494","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!../app/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/shengji.vue
// module id = null
// module chunks = 